import { Box, IconButton } from '@mui/material';
import { useDoctorList } from 'app/hooks';
import { IDoctorSchema } from 'generated/axios';
import { Typography } from '../typography';
import { t } from 'i18next';
import { List } from '../list';

import ClearIcon from '@mui/icons-material/Clear';
import RefreshIcon from '@mui/icons-material/Refresh';

interface Props {
  onConfirmDoctor: (company: IDoctorSchema) => void;
  onCancel: () => void;
}

export const SearchDoctor = ({ onConfirmDoctor, onCancel }: Props) => {
  const { list, count, page, pageSize, handlePageChange, handlePageSizeChange, refresh, loading } = useDoctorList({
    isActive: true,
  });

  return (
    <>
      <Box bgcolor={'primary.main'} padding={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        <Box display={'inherit'} alignItems={'inherit'}>
          <Typography color={'common.white'} variant="h6">
            {t('doctor.select')}
          </Typography>
          <IconButton onClick={refresh}>
            <RefreshIcon sx={{ color: 'common.white' }} />
          </IconButton>
        </Box>

        <IconButton onClick={onCancel}>
          <ClearIcon sx={{ color: 'common.white' }} />
        </IconButton>
      </Box>
      <List
        list={list}
        page={page}
        pageSize={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        count={count}
        keyGetter={(el) => el.id}
        onItemClick={onConfirmDoctor}
        fields={[
          {
            title: t('doctor.lastName'),
            key: 'last_name',
          },
          {
            title: t('doctor.firstName'),
            key: 'first_name',
          },
        ]}
      />
    </>
  );
};
